import { useUserAuth } from '../../../state/userAuthContext';
import { NudosGenericModal } from '../../NudosComponents';
import './LogoutModal.scss';

/**
 * Componente modal para confirmar el cierre de sesión
 */
const Logout = ({ closeModalCallback }: { closeModalCallback: () => void }) => {
  const { logOut } = useUserAuth();

  const handleClickLogout = () => {
    logOut && logOut();
    closeModalCallback();
  };

  if (!logOut) return <></>;

  return (
    <NudosGenericModal
      modalContent={<LogoutModal onClickLogout={handleClickLogout} closeLogoutModal={closeModalCallback} />}
      closesOnClickOutside={true}
      clickOutsideCallback={closeModalCallback}
      closeModalCallback={closeModalCallback}
      customClassName="logoutModalCustom"
    />
  );
};

/**
 * Contenido del modal de logout con opciones de confirmación
 */
const LogoutModal = ({
  onClickLogout,
  closeLogoutModal
}: {
  onClickLogout: () => void;
  closeLogoutModal: () => void;
}) => {
  return (
    <div className="logoutModalContent">
      <div className="logoutModalQuestion">¿Seguro quieres cerrar sesión?</div>
      <div className="logoutModalAnswers">
        <button className="logoutModalButton" onClick={onClickLogout}>Si</button>
        <button className="logoutModalButton" onClick={closeLogoutModal}>No</button>
      </div>
    </div>
  );
};

export default Logout;
